<template>
  <div class="columns is-centered">
    <div class="column is-5 py-6">
      <div class="py-5 px-5">
        <div class="columns is-centered">
          <div class="column">
              <b-field label="Inicio" label-position="inside">
                <b-datepicker
                    v-model="fromDate"
                    :first-day-of-week="1"
                    :month-names="$moment.months()"
                    :day-names="$moment.weekdaysShort()"
                    :show-week-number="true"
                    placeholder="Click para seleccionar"
                    :max-date="toDate"
                    icon="calendar-today">
                </b-datepicker>
              </b-field>
              <b-field label="Fin" label-position="inside">
                  <b-datepicker
                      v-model="toDate"
                      :first-day-of-week="1"
                      :month-names="$moment.months()"
                      :day-names="$moment.weekdaysShort()"
                      :show-week-number="true"
                      placeholder="Click para seleccionar"
                      position="is-bottom-left"
                      :min-date="fromDate"
                      icon="calendar-today">
                  </b-datepicker>
              </b-field>
              <b-field label="¿Incluir jinetes inactivos?">
                <b-switch v-model="includeInactive"
                    :true-value="null"
                    :false-value="1">
                    {{ !includeInactive ? 'Si' : 'No' }}
                </b-switch>
            </b-field>
          </div>
        </div>
        <div class="columns is-centered">
          <div class="column is-6 pt-4 pb-4 px-3">
            <b-button type="is-primary"  size="is-medium" expanded :loading="isLoadingDownload" @click="downloadSummary">Generar Reporte</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TenantService from '@/services/TenantService.js'

export default {
  data () {
    let fromDate = this.$moment().subtract(1, 'months').toDate()
    let toDate = this.$moment().toDate()
    return {
      fromDate: fromDate,
      toDate: toDate,
      includeInactive: 1,
      isLoadingDownload: false
    }
  },
  methods: {
    async downloadSummary () {
      this.isLoadingDownload = true
      let params = {
        from: this.$moment(this.fromDate).format('YYYY-MM-DD'),
        to: this.$moment(this.toDate).format('YYYY-MM-DD'),
        active: this.includeInactive
      }
      let fromDateFormat = this.$moment(this.fromDate).format('DD-MM-YYYY')
      let toDateFormat = this.$moment(this.toDate).format('DD-MM-YYYY')
      let playload = await this.downloadGeneralResults(params)
      let fileName = `Resultados ESA-EAE Período ${fromDateFormat} al ${toDateFormat}.pdf`
      this.generateFile(playload, fileName, 'application/pdf; charset=utf-8')
      this.openAlert()
      this.isLoadingDownload = false
    },
    openAlert () {
      this.$buefy.notification.open({
        duration: 4000,
        icon: 'account',
        message: `<icon class="mdi mdi-24px mdi-download"></icon> La descarga comenzará dentro de poco`,
        position: 'is-bottom-left',
        type: 'is-info',
        hasIcon: false
      })
    },
    async downloadGeneralResults (params) {
      let response = await TenantService.downloadGeneralResults(params)
      return response.data
    },
    async generateFile (data, fileName, fileType) {
      var blob = new Blob([data], { type: fileType })
      var fileURL = window.URL.createObjectURL(blob)
      var fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', fileName)
      document.body.appendChild(fileLink)
      fileLink.click()
    }
  }
}
</script>
